// Core
import {useState, useEffect, useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';

// Chakra 
import {
    Box,
    Flex,
    Image,
    Text,
    Table,
    Tbody,
    Thead,
    Tr,
    Td,
    useColorModeValue,
    useDisclosure
} from '@chakra-ui/react';

// Assets
import {apiService} from 'services/ApiService';
import {getInitials} from 'services/Utils';

// Components
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';
import {RoleIcon} from '../../../../components/Icons/Icons';
import ChangeRoleModal from './components/ChangeRoleModal';

const Admins = () => {
    const textColor = useColorModeValue('gray.700', 'white');
    const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');
    const paddingTd = '16px 0 16px 24px';

    const history = useHistory();

    const [offset] = useState(0);

    const [dataUsers, setDataUsers] = useState([]);
    const fetchDataUser = useCallback(async () => {
        try {
            const response = await apiService.getUsers({limit: 25, offset});
            setDataUsers(response.data);
        } catch (error) {
        }
    }, [offset]);

    useEffect(() => {
        fetchDataUser(offset);
    }, [fetchDataUser, offset]);

    const handleUserDataOpen = useCallback((user) => {
        // history.push(`/users/${user.id}`);
    }, [history]);


    const isRoles = usePermissionStatusByKey('GET:/admin/roles');
    const isUpdateUserRole = usePermissionStatusByKey('POST:/admin/users/:id/role');
    const isUserDetails = usePermissionStatusByKey('GET:/admin/users/:id/details');
    const isPlainUser = usePermissionStatusByKey('GET:/admin/users/:id');
    const isUser = isPlainUser || isUserDetails;

    const {
        isOpen: isOpenChangeRole,
        onOpen: onOpenChangeRole,
        onClose: onCloseChangeRole,
    } = useDisclosure();

    const [user, setUser] = useState(null);

    const onRowClick = (user) => {
        console.log('onRowClick', user);
        if (isRoles && isUpdateUserRole) {
            setUser(user);
            onOpenChangeRole();
        }

    };

    const onModalClose = () => {
        setUser(null);
        onCloseChangeRole();
    };

    return (
        <>
            <>

                <Card padding="8px 0 0 0" overflow="hidden">
                    <CardBody>
                        <Table color={textColor}>
                            <Thead>
                                <Tr>
                                    <Td><Text variant="title-md" p='0 0 6px 0'>Name</Text></Td>
                                    <Td><Text variant="title-md" p='0 0 6px 0'>Status</Text></Td>
                                    <Td><Text variant="title-md" p='0 0 6px 0'>Email</Text></Td>
                                    {isRoles && isUpdateUserRole && (
                                        <Td><Text
                                            variant="title-md" p='0 0 6px 0'>Change Role</Text></Td>
                                    )}

                                </Tr>
                            </Thead>
                            <Tbody>
                                {dataUsers.map((row) => {
                                    return (
                                        <Tr key={row.id} border="unset" cursor={isUser ? 'pointer' : 'default'}
                                            className={isUser ? 'cursor-tr' : ''}>
                                            <Td onClick={() => isUser && handleUserDataOpen(row)} verticalAlign="center"
                                                p={paddingTd}>
                                                <Flex gap="8px">
                                                    {row?.image ? (
                                                        <Image src={row?.image} w="41px" h="41px" borderRadius="full"
                                                               objectFit="cover"/>
                                                    ) : (
                                                        <Box
                                                            className={row?.gender === 'Male' ? 'gender-male' : row?.gender === 'Female' ? 'gender-female' : row?.gender === 'Transgender' ? 'gender-other' : 'gender-none'}>
                                                            <Text>{getInitials(row?.firstName, row?.lastName)}</Text>
                                                        </Box>
                                                    )}
                                                    <Flex position="relative">
                                                        <Text variant="text" color={textColor}
                                                              pt="10px">{row.firstName} {row.lastName}</Text>
                                                    </Flex>
                                                </Flex>
                                            </Td>
                                            <Td onClick={() => isUser && handleUserDataOpen(row)} verticalAlign="center"
                                                p={paddingTd}>
                                                <Text mt="-1px" variant="text-md"
                                                      className={
                                                          row.role === 'Admin' ? 'tag-red' : 'tag-purple'
                                                      }
                                                >{row.role}</Text>
                                            </Td>
                                            <Td onClick={() => isUser && handleUserDataOpen(row)} verticalAlign="center"
                                                p={paddingTd}>
                                                <Text variant="text" color={textColor}>{row.email}</Text>
                                            </Td>
                                            {isRoles && isUpdateUserRole && (
                                                <Td><RoleIcon
                                                    color="#099BFF"
                                                    onClick={() => onRowClick(row)}
                                                    cursor="pointer"
                                                    p="11px"
                                                    w="44px"
                                                    h="44px"
                                                    border="1px solid #0D234D"
                                                    borderRadius="10px"
                                                />
                                                </Td>
                                            )}

                                        </Tr>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </CardBody>
                </Card>
                <ChangeRoleModal
                    user={user}
                    isOpen={isOpenChangeRole}
                    onClose={onModalClose}
                />

            </>
        </>
    );
};

export default Admins;
